export default __webpack_public_path__ + "static/media/benefitsRightBlur.1bd78f3a.png";